const UPLOAD_ANCHOR_PREFIX = "upload-source";

export const getUploadAnchorId = (
  submissionTime?: string | null
): string | undefined =>
  submissionTime ? `${UPLOAD_ANCHOR_PREFIX}-${submissionTime}` : undefined;
